import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { LanguageStatisticsModuleName } from '@/store/modules/modules'

export class LanguageStatisticsViewModel {
  private store = useStore()

  chartData: ComputedRef<{ labelChartData: string[]; languageStatisticsChartData: number[][]; maxTotal: number }> =
    computed(() => this.store.getters[`${LanguageStatisticsModuleName}/chartData`])
  chartSeries: ComputedRef<any[]> = computed(() => this.store.getters[`${LanguageStatisticsModuleName}/chartSeries`])
  chartOptions: ComputedRef<any> = computed(() => this.store.getters[`${LanguageStatisticsModuleName}/chartOptions`])

  setChartData(chartData: {
    labelChartData: string[]
    languageStatisticsChartData: number[][]
    maxTotal: number
  }): void {
    this.store.commit(`${LanguageStatisticsModuleName}/setChartData`, chartData)
  }

  setChartSeries(chartSeries: any[]): void {
    this.store.commit(`${LanguageStatisticsModuleName}/setChartSeries`, chartSeries)
  }

  setChartOptions(chartOptions: any): void {
    this.store.commit(`${LanguageStatisticsModuleName}/setChartOptions`, chartOptions)
  }
}
